export default function roundMoney(number: number | string | null){
  if(!number) return
  if(typeof number === 'string'){
      number = parseInt(number)
  }
  
  return number % 1 === 0 ? number.toFixed(0) : number.toFixed(2);
}
